module.exports = __webpack_public_path__ + "img/teacher.10a8361b.png";